import React from 'react';
import { FlexWrapper } from '@yme/tokens/flexTokens';
export function TabsContent({ tabData, activeTab }) {
    return (React.createElement(FlexWrapper, { flexDirection: "column" }, tabData.map(({ entityId, tabContent }) => (React.createElement("div", { key: entityId }, activeTab.entityId === entityId && tabContent)))));
}
TabsContent.displayName = 'TabsContent';
